import { WeightUnits } from '@app/objects/Crematory';

export const units: Record<WeightUnits, string> = {
	[WeightUnits.Kilograms]: 'kg',
	[WeightUnits.Pounds]: 'lb',
};

abstract class WeightUnit {
	/* Name of main unit (for example - lb) */
	public abstract name: string;

	/* Name of fraction unit (for example - oz) */
	public abstract fractionName: string;

	/* Convert from main unit to fraction unit */
	public abstract unitToFraction(value: number): number;
}

/**
 * PoundUnit - perform operations with pounds
 */
class PoundUnit extends WeightUnit {
	public name: string = 'lb';
	public fractionName: string = 'oz';

	public unitToFraction(value: number): number {
		return value * 16;
	}
}

/**
 * KiloUnit - perform operations with kilograms
 */
class KiloUnit extends WeightUnit {
	public name: string = 'kg';
	public fractionName: string = 'g';

	public unitToFraction(value: number): number {
		return value * 1000;
	}
}

export function toUnit(unit: WeightUnits): WeightUnit {
	switch (unit) {
	case WeightUnits.Kilograms: return new KiloUnit();
	case WeightUnits.Pounds: return new PoundUnit();

	default:
		throw new Error(`Unknown unit: ${unit}`);
	}
}
